import Vue from 'vue';

import { RouteName } from '@app/router/constants/RouteName';

let markRegistrationResolved: AnyFunction;
// We need the property to be reactive for 2 reasons:
// 1. So that we can remove the loading state of our app after federation routes are registered
// 2. So that we can change the component type in CustomRouterLink.vue which resolves to a 'div' if route registration isn't finished
// and to 'router-link' if it is finished
const routeRegistration = Vue.observable({
    areRegistered: false,
});

export const areRoutesRegisteredPromise = new Promise((resolve) => {
    markRegistrationResolved = resolve;
});

export function markRoutesAsRegistered() {
    routeRegistration.areRegistered = true;
    markRegistrationResolved();
}

export function areRoutesRegistered() {
    return routeRegistration.areRegistered;
}

export function shouldWaitForRouteRegistration(currentRouteName: string | null | undefined) {
    // RouteName.App.CatchAll is resolved name in route guards for federation routes before route registration is finished
    // Initially, while our app is being loaded the current route ($route in App.vue) is resolved to a route object with path '/' and name null
    // This means that the route still isn't resolved successfully and we should wait for the route to resolve to something more meaningful.
    // In those two cases we should wait for route registration to finish before proceeding
    return currentRouteName == null || currentRouteName === RouteName.App.CatchAll || currentRouteName === RouteName.Account.Register || currentRouteName === RouteName.Account.ContinueRegistration;
}
